import React, { Component } from 'react';
import { Button, Col, DatePicker, Form, Input, Row, Select } from 'antd';
import { connect } from 'react-redux';

const FormItem = Form.Item;
const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  /**
   * 发票搜索
   */
  search = e => {
    e.preventDefault();
    const data = this.props.form.getFieldsValue();
    this.props.search(data);
  };

  reset = e => {
    e.preventDefault();
    this.props.form.setFieldsValue({
      no: undefined,
      status: undefined,
      type: undefined,
      useTime: undefined,
    });
    const data = this.props.form.getFieldsValue();
    this.props.search(data);
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    return (
      <Form className="search-form" onSubmit={this.search}>
        <Row justify="space-between" type="flex">
          <Col span={5}>
            <FormItem>{getFieldDecorator('no')(<Input placeholder="发票编号" />)}</FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="开票日期" {...formItemLayout}>
              {getFieldDecorator('useTime')(
                <DatePicker placeholder="开票日期" style={{ width: '100%' }} />,
              )}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem label="状态" {...formItemLayout}>
              {getFieldDecorator('status')(
                <Select placeholder="状态">
                  <Option value="1">未使用</Option>
                  <Option value="2">已使用</Option>
                  <Option value="3">已作废</Option>
                  <Option value="4">已冲红</Option>
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={5}>
            <FormItem label="发票类型" {...formItemLayout}>
              {getFieldDecorator('type')(
                <Select>
                  <Option key="1">国税网络在线发票</Option>
                  <Option key="2">增值税专用发票</Option>
                  <Option key="3">增值税普通发票</Option>
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem>
              <Row type="flex" justify="end">
                <Button type="primary" htmlType="submit" style={{ marginRight: '10px' }}>
                  搜索
                </Button>
                <Button onClick={this.reset} style={{ marginRight: '10px' }}>
                  重置
                </Button>
              </Row>
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default connect(state => state)(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/xianxing/invoice/FormSearch.js